import { Box, FormControl, FormLabel, Stack, Text } from '@chakra-ui/react';
import { Field } from 'formik';
import { useState } from 'react';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { Input } from 'components/v4';
import {
    descriptionStyling,
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const TRSRegistrationRegistrarField = ({
    errors,
    touched,
    darkMode,
    registrationData,
    isDisabled = true, // Always read-only
}) => {
    const [isHovered, setIsHovered] = useState(false);

    const displayValue =
        registrationData?.registrar?.name || 'Unknown Registrar';

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.registrarID && touched.registrarID}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(true), ...formInputStyles }}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Registrar{' '}
                        <span className="font-medium text-gray-400">
                            (read-only)
                        </span>
                    </FormLabel>
                    <Text
                        sx={{
                            ...descriptionStyling,
                            color: darkMode ? 'gray.100' : '#757575',
                        }}
                        maxW={250}>
                        The registrar handling this registration
                    </Text>
                </Box>
                <Field name="registrarID">
                    {({ field }) => (
                        <Box className="w-full pt-[22px]">
                            <Input
                                {...field}
                                value={displayValue}
                                isDisabled={isDisabled}
                                placeholder="Registrar name"
                                className="!h-[30px] rounded-[5px] pl-2"
                                style={{
                                    backgroundColor: darkMode
                                        ? '#1E2021'
                                        : '#F7FAFC',
                                    color: darkMode ? '#A0AEC0' : '#4A5568',
                                }}
                            />
                        </Box>
                    )}
                </Field>
                {isHovered && (
                    <FieldToolTip
                        label="This shows the registrar system that handles this TRS registration. This field cannot be edited."
                        ariaLabel="registrar-tip"
                        left="25px"
                        top="32px"
                    />
                )}
            </Stack>
            <FieldError
                error={errors?.registrarID}
                touched={touched?.registrarID}
            />
        </FormControl>
    );
};

export default TRSRegistrationRegistrarField;
